exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-nosotros-jsx": () => import("./../../../src/pages/nosotros.jsx" /* webpackChunkName: "component---src-pages-nosotros-jsx" */),
  "component---src-pages-proyectos-jsx": () => import("./../../../src/pages/proyectos.jsx" /* webpackChunkName: "component---src-pages-proyectos-jsx" */),
  "component---src-pages-servicios-jsx": () => import("./../../../src/pages/servicios.jsx" /* webpackChunkName: "component---src-pages-servicios-jsx" */)
}

